<template>
  <v-dialog v-model="open" max-width="500px" persistent>
    <template v-slot:activator="{ on, attrs }">
      <location-info-item
          icon-action="mdi-pencil-outline"
          :title="location.data ? location.data.location_name : ''"
          titleClass="title"
          v-bind="attrs"
          v-on="on"
      />
    </template>

    <v-card>
      <v-toolbar elevation="0">
        <v-card-title class="ml-0 pl-1">
          Nome da empresa
        </v-card-title>

        <v-spacer />

        <v-btn icon @click="open = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text>
        Insira o nome do negócio da forma como ele aparece para os clientes no mundo real.
      </v-card-text>

      <v-card-text>
        <v-form
            ref="form"
            v-model="formValid"
            lazy-validation
        >
          <v-text-field
              v-model="formData.location_name"
              :counter="100"
              :rules="nameRules"
              required
              outlined
          ></v-text-field>

          <v-alert
            v-if="alertScheduledTask"
            dense
            border="right"
            type="warning"
          >
            Existe um agendamento pendente para essa informação
          </v-alert>

          <schedule-form  v-if="!bulkUpdate" small v-on:change="changeScheduleDate" />
        </v-form>
      </v-card-text>

      <v-divider />

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
            color="secondary"
            text
            @click="cancel"
        >
          Cancelar
        </v-btn>
        <v-btn
            :loading="loading"
            color="primary"
            text
            @click="callAction"
        >
          Aplicar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import LocationInfoItem from '@/views/Locations/Components/LocationInfoItem'
import {mapState} from 'vuex'
import {get} from 'lodash'
import {TYPE_UPDATE_LOCATION_LOCATION_NAME} from '@/constants/tasks'
import ScheduleForm from '@/views/Locations/Components/ScheduleForm'

export default {
  name: 'LocationNameModal',
  props: {
    action: {
      type: Function,
      required: true,
    },
    bulkUpdate: {
      type: Boolean,
    },
    alertScheduleTask: Array,
  },
  components: {
    ScheduleForm,
    LocationInfoItem
  },
  methods: {
    cancel: function() {
      this.open = false
      this.resetData()
    },
    resetData: function() {
      const {location_name} = this.formDataOriginal
      this.formData.location_name = location_name
    },
    callAction: async function () {
      this.validate()
      if (this.formValid) {
        this.loading = true
        await this.action(this.formData)
        this.open = false
        this.loading = false
      }
    },
    validate: function () {
      return this.$refs.form.validate()
    },
    changeScheduleDate: function(data) {
      this.formData.schedule_start = data.schedule_start
      this.formData.schedule_start_at = data.schedule_start_at
      this.formData.schedule_end = data.schedule_end
      this.formData.schedule_end_at = data.schedule_end_at
    },
  },
  computed: {
    ...mapState({
      location: state => state.locations.location,
    }),
  },
  data: () => ({
    open: false,
    loading: false,
    formValid: true,
    formData: {
      schedule_type: TYPE_UPDATE_LOCATION_LOCATION_NAME,
      schedule_start: '',
      schedule_start_at: '',
      schedule_end: '',
      schedule_end_at: '',
      location_name: '',
    },
    formDataOriginal: {},
    nameRules: [
      v => !!v || 'O nome da empresa é obrigatório',
      v => (v && v.length <= 100) || 'Nome precisa ter menos de 100 caracteres',
    ],
    alertScheduledTask: null,
  }),
  mounted() {
    if(this.alertScheduleTask) {
      this.alertScheduleTask.map(type => {
        if(type === TYPE_UPDATE_LOCATION_LOCATION_NAME) {
          this.alertScheduledTask = true;
        }
      })
    }
  },
  watch: {
    location: function (location) {
      this.formData.location_name = get(location, 'data.location_name')
      this.formDataOriginal.location_name = get(location, 'data.location_name')
    },
    open: function (open) {
      if (open) {
        this.formData.location_name = get(this.location, 'data.location_name')
        this.formDataOriginal.location_name = get(this.location, 'data.location_name')
      }
    }
  },
}
</script>

<style scoped>

</style>